<template>
    <router-link
        :to="{
            name: RoutesEnum.COMPANY.MY_COMPANY,
            params: { id: company.id.toString(), tabType: 'profile' },
        }"
    >
        <div class="company-card">
            <div class="company-card__image">
                <common-company-avatar :company="company" size="small"></common-company-avatar>
            </div>

            <div class="company-card__name">{{ company.name }}</div>
            <p>{{ company.address }}</p>
            <p>{{ company.city.name }}</p>
            <div class="company-card__pib">{{ $t('pages.company.my_companies.card.pib') + ': ' + company.pib }}</div>
        </div>
    </router-link>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'

    export default {
        props: {
            company: { type: Object, default: undefined },
        },

        data: () => ({ RoutesEnum }),
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/company/_company-card.scss';
</style>
